import type { PropsWithChildren } from 'react'
import type { FavoriteViewsPageActions } from './FavoriteViewsPageActionsContext'
import { FavoriteViewsPageActionsContext } from './FavoriteViewsPageActionsContext'

interface FavoriteViewsPageActionsProviderProps extends PropsWithChildren {
  value: FavoriteViewsPageActions
}

export function FavoriteViewsPageActionsProvider({
  value,
  children,
}: Readonly<FavoriteViewsPageActionsProviderProps>) {
  return (
    <FavoriteViewsPageActionsContext value={value}>
      {children}
    </FavoriteViewsPageActionsContext>
  )
}
